import $ from "jquery";
import collectDataAttributesFor from "../utilities/collectDataAttributesFor";
import {instantiateSelect2, bindDocSelect2CloseRefocus, bindSelect2OnTypeForDesktop} from "../utilities/select2able";
import {instantiateSwitchery} from "../utilities/instantiateSwitchery";

import {bindTopNavHamburger} from "../utilities/jumboNav";

import {triggerSelectResize} from "../utilities/select2MultiSelectResize";

import generateDatePicker from "../utilities/datePicker";


$(()=>{
  
  $.fn.select2.amd.require(['select2/selection/search'], function (Search) {
    var oldRemoveChoice = Search.prototype.searchRemoveChoice;
    
    Search.prototype.searchRemoveChoice = function () {
        oldRemoveChoice.apply(this, arguments);
        this.$search.val('');
    };

    instantiateSelect2($('.select2-select'));
  });
  
  instantiateSwitchery($('.js-switchery'));
  
  generateDatePicker($('.datepicker'));

  $(document).on("focus", "input", function(e){
    // add focus class to parent element of any possible input
    // to handle wrapper class styling
    $(e.target).parent().addClass('focus');
  });

  $(document).on("blur", "input", function(e){
    $(e.target).parent().removeClass('focus');
  });

  //Common Error modal
  $(document).ajaxError(
	function(event, response, settings, thrownError) {
		if(response.status == 500){
			$('#commerce-error-wrapper').html(response.responseText);
			$('#commerce-error-wrapper .modal.commerce-error-modal ').modal("show");
			$('#commerce-error-wrapper .modal.commerce-error-modal ').css({'z-index':'99999999'});
			$( ".modal" ).not( ".commerce-error-modal" ).modal("hide");
		}
	}
  );


  bindDocSelect2CloseRefocus();

  bindTopNavHamburger($('.top-nav-burger'));

  triggerSelectResize();
  bindSelect2OnTypeForDesktop();
});



// WEBPACK FOOTER //
// ./src/pages/all.js